var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone.fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "phone.fill_2",
    d: "M10.7559 17.6895C13.3486 20.291 16.5039 22.2949 19.0791 22.2949C20.2305 22.2949 21.2412 21.8906 22.0498 20.9941C22.5244 20.4668 22.8145 19.8604 22.8145 19.2539C22.8145 18.7881 22.6299 18.3311 22.1816 18.0146L19.4834 16.0986C19.0527 15.7998 18.7012 15.6592 18.3848 15.6592C17.9717 15.6592 17.6025 15.8877 17.1982 16.292L16.5654 16.9248C16.46 17.0215 16.3369 17.0654 16.2227 17.0654C16.082 17.0654 15.9502 17.0127 15.8623 16.96C15.3086 16.6611 14.3594 15.8525 13.4805 14.9736C12.6016 14.0947 11.7842 13.1543 11.4941 12.5918C11.4414 12.4951 11.3975 12.3721 11.3975 12.2314C11.3975 12.126 11.4326 12.0029 11.5293 11.8975L12.1621 11.2559C12.5576 10.8428 12.7949 10.4824 12.7949 10.0693C12.7949 9.74414 12.6543 9.39258 12.3555 8.9707L10.4482 6.29883C10.123 5.8418 9.66602 5.64844 9.16504 5.64844C8.56738 5.64844 7.96973 5.91211 7.45117 6.41309C6.57227 7.23926 6.18555 8.26758 6.18555 9.40137C6.18555 11.9766 8.16309 15.0967 10.7559 17.6895Z",
    fill: "#B5B5B5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneGray);
export default __webpack_public_path__ + "static/media/phone-gray.98df98179821d5a126e6d6426b87dbdf.svg";
export { ForwardRef as ReactComponent };